export const familyEtabMock = [
  {
    id: 1,
    ordre: 0,
    code: "CAFE_REST",
    nom: "Cafés / Restaurants",
    categories: [
      {
        id: 50,
        code: "REST_PLAGE",
        nom: "Restaurant de Plage",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/c6/eb/32/c6eb32cd3f4f7aeb8bf697ee0fbd884e.jpg",
      },
      {
        id: 2,
        ordre: -1,
        code: "BRASS_CHIC",
        nom: "Bistrot",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/d5/b7/cc/d5b7cc26401bd97d348bc28b8e69418d.jpg",
        favori: 1,
      },
      {
        id: 15,
        ordre: 0,
        code: "REST_WORLD",
        nom: "Restaurant World food",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/c8/e7/cd/c8e7cd7aa3dfa982d039b78b6fb90937.jpg",
      },
      {
        id: 16,
        ordre: 0,
        code: "REST_FRUIT",
        nom: "Restaurant de fruits de mer",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/48/25/2a/48252a08b4512914c14a5f010ba4dfe9.jpg",
      },
      {
        id: 17,
        ordre: 0,
        code: "CREPERIE",
        nom: "Crêperie",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/72/2f/96/722f96d0edce7a794ef483b388dc8f7b.jpg",
      },
      {
        id: 18,
        ordre: 0,
        code: "PIZZERIA",
        nom: "Pizzeria",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/5f/fd/4f/5ffd4fd66cbb008400db05094f45f108.jpg",
      },
      {
        id: 20,
        ordre: 0,
        code: "REST_BIOVE",
        nom: "Restaurant Bio/Vegan",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/7c/73/4f/7c734f115108fce9fc9f7f5790349f1a.jpg",
      },
      {
        id: 21,
        ordre: 0,
        code: "COFFEE_SHO",
        nom: "Coffee-shop",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/e3/34/65/e33465537732375c57f2d2d30aeab3b2.jpg",
      },
      {
        id: 22,
        ordre: 0,
        code: "SALONTHE",
        nom: "Salon de thé",
        photo: "https://extradev.s3.eu-central-1.amazonaws.com/d8/61/4d/d8614dbdf596c07e5b27c62780edf124.jpg",
      },
      {
        id: 23,
        ordre: 0,
        code: "CAFETERIA",
        nom: "Cafétéria",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/52/9d/5f/529d5f2f18d332eca6e85d01d23876ad.jpg",
      },
      {
        id: 24,
        ordre: 0,
        code: "REST_CONCE",
        nom: "Restaurant - Concert",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/ad/73/fe/ad73febb091c83d0a8185815f694af2d.jpg",
      },
      {
        id: 14,
        ordre: 0,
        code: "REST_SUD_A",
        nom: "Restaurant Sud-américain",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/0b/c4/1a/0bc41a7f6f3ceb8a46f7c698af766a98.jpg",
      },
      {
        id: 13,
        ordre: 0,
        code: "REST_ASIAT",
        nom: "Restaurant Asiatique",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/77/5e/a0/775ea0961f473350b479f5e9e348666b.jpg",
      },
      {
        id: 12,
        ordre: 0,
        code: "REST_ITALI",
        nom: "Restaurant Italien",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/c1/03/9b/c1039bfd6fb9869b0967b700bb0028c8.jpg",
        favori: 1,
      },
      {
        id: 3,
        ordre: 0,
        code: "CAF_REST",
        nom: "Café - Restaurant",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/cc/3f/f7/cc3ff7849457cf9b61a9a29ccbb7c23c.jpg",
        favori: 1,
      },
      {
        id: 4,
        ordre: 0,
        code: "BISTROT",
        nom: "Bistrot",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/3b/7e/c6/3b7ec6e167e220398a816d45aa6feea0.jpg",
        favori: 1,
      },
      {
        id: 5,
        ordre: 0,
        code: "REST_BAR",
        nom: "Restaurant - Bar",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/be/a5/f9/bea5f983c446eab2ec52bade1eb18761.jpg",
      },
      {
        id: 6,
        ordre: 0,
        code: "REST_CHIC",
        nom: "Restaurant Chic",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/ae/35/c3/ae35c39f95722257b297843265b27b8e.jpg",
      },
      {
        id: 7,
        ordre: 0,
        code: "NEO_BISTRO",
        nom: "Néo-bistrot",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/cc/d9/5e/ccd95e042812ad637b7576386541bec4.jpg",
        favori: 1,
      },
      {
        id: 8,
        ordre: 0,
        code: "CONCEPT_FO",
        nom: "Concept food",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/09/5a/06/095a06da7a432fd7c078d09c3d883af3.jpg",
      },
      {
        id: 9,
        ordre: 0,
        code: "REST_BISTR",
        nom: "Restaurant Bistronomique",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/32/a8/ea/32a8eacc9fd39a76283502a9abc7d797.jpg",
      },
      {
        id: 10,
        ordre: 0,
        code: "REST_GASTR",
        nom: "Restaurant Gastronomique",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/bc/24/d0/bc24d064ef44f9da744a0b629c27609e.jpg",
      },
      {
        id: 11,
        ordre: 0,
        code: "REST_BURGE",
        nom: "Restaurant de burger",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/74/d8/d5/74d8d5d0ae9dc0e6bf4240c6d8a644c9.jpg",
      },
      {
        id: 1,
        ordre: 0,
        code: "BRASSERIE",
        nom: "Brasserie",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/20/7e/d9/207ed92369299d1676a8c70626cba4be.jpg",
        favori: 1,
      },
    ],
  },
  {
    id: 2,
    ordre: 0,
    code: "BAR_CLUB",
    nom: "Bars / Clubs",
    categories: [
      {
        id: 55,
        code: "BAR—TABAC",
        nom: "Bar-Tabac",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/e9/0d/f3/e90df3865c3315ea7fc163af901f259e.jpg",
      },
      {
        id: 51,
        code: "BAR_PLAGE",
        nom: "Bar de Plage",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/06/d7/e6/06d7e639e9e754e9dd02b906c70c1ad4.jpg",
      },
      {
        id: 34,
        ordre: 0,
        code: "CLUB_ADULT",
        nom: "Club pour adultes",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/cb/7a/7e/cb7a7ed0a54e0977d0a1e33320f0bfe4.jpg",
      },
      {
        id: 32,
        ordre: 0,
        code: "CLUB",
        nom: "Club",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/73/46/00/734600a4d855bb28ad93b3b48de9b1ea.jpg",
      },
      {
        id: 31,
        ordre: 0,
        code: "BAR_CLUB",
        nom: "Bar-Club",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/34/8d/ca/348dcac62195ab2cec3774794ecf9251.jpg",
        favori: 1,
      },
      {
        id: 30,
        ordre: 0,
        code: "COCK_BAR",
        nom: "Cocktail-Bar",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/63/99/77/639977e71b69427b32130a85390f1b9c.jpg",
      },
      {
        id: 29,
        ordre: 0,
        code: "BAR_A_VIN",
        nom: "Bar à vin",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/7a/72/cc/7a72cce32a0c11cb0f8f8c0ff4d82c9a.jpg",
        favori: 1,
      },
      {
        id: 28,
        ordre: 0,
        code: "CAFE_BAR",
        nom: "Café - Bar",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/7e/3f/72/7e3f72c08354c0e4ea1d502866b94976.jpg",
        favori: 1,
      },
      {
        id: 27,
        ordre: 0,
        code: "BAR_PUB",
        nom: "Bar-Pub",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/42/85/a6/4285a6f9b1d95ac8c89dbfcee1a9f5c9.jpg",
      },
      {
        id: 26,
        ordre: 0,
        code: "BAR_REST",
        nom: "Bar-Restaurant",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/78/ab/ae/78abaeeacd8019d9c3547262e2111f29.jpg",
        favori: 1,
      },
      {
        id: 25,
        ordre: 0,
        code: "BAR",
        nom: "Bar",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/23/55/0e/23550e81e178e7440505e383642e9f24.jpg",
        favori: 1,
      },
    ],
  },
  {
    id: 3,
    ordre: 0,
    code: "HOTEL",
    nom: "Hôtel",
    categories: [
      {
        id: 35,
        ordre: 0,
        code: "HOTEL_1ET",
        nom: "Hôtel *",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/f2/0e/58/f20e58d6fb79bd57de409fae0d92384c.jpg",
        segment: "Hôtel indépendant",
      },
      {
        id: 36,
        ordre: 0,
        code: "HOTEL_2ET",
        nom: "Hôtel **",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/b1/e3/8b/b1e38b58a9cc72b462cd61fc78679a3f.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
      {
        id: 37,
        ordre: 0,
        code: "HOTEL_3ET",
        nom: "Hôtel ***",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/54/44/4a/54444a50811d8833213128e91671027e.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
      {
        id: 38,
        ordre: 0,
        code: "HOTEL_4ET",
        nom: "Hôtel ****",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/96/57/28/965728003e51c0b04ae4e00fa4b9b299.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
      {
        id: 39,
        ordre: 0,
        code: "HOTEL_5ET",
        nom: "Hôtel *****",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/e2/2b/0b/e22b0b75034b436a0e86de990eccd387.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
      {
        id: 40,
        ordre: 0,
        code: "AUBERGE_JE",
        nom: "Auberge de jeunesse",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/be/53/6d/be536d1cea7f158ff22e182388f78d34.jpg",
        segment: "Hôtel indépendant",
      },
      {
        id: 41,
        ordre: 0,
        code: "REST_HOTEL",
        nom: "Restaurant d'hôtel",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/b2/e7/88/b2e78830ddad473faa52e4ee66768581.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
      {
        id: 42,
        ordre: 0,
        code: "BAR_HOTEL",
        nom: "Bar d'hôtel",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/a2/f5/9c/a2f59ce962636a39243f3f46ac3fa580.jpg",
        favori: 1,
        segment: "Hôtel indépendant",
      },
    ],
  },
  {
    id: 5,
    ordre: 0,
    code: "A_EMPORTER",
    nom: "Vente à emporter",
    categories: [
      {
        id: 54,
        code: "BOULANG",
        nom: "Boulangerie",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/7f/63/51/7f6351c78959af4e03eb362c0b0a220b.jpg",
        segment: "Retail food",
      },
      {
        id: 56,
        code: "BAR—SALADE",
        nom: "Bar à Salade",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/8f/ce/29/8fce29db0c75faf11cb0fd3a8cb7e9af.jpg",
        segment: "Retail food",
      },
      {
        id: 58,
        code: "GLACIER",
        nom: "Glacier",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/1e/11/a6/1e11a6b6a7974b3e5948a96d05f29dfd.jpg",
        segment: "Retail food",
      },
      {
        id: 60,
        code: "PATISSERIE",
        nom: "Pâtisserie",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/bb/ed/4b/bbed4b98906acf1f994314e0309cfc00.jpg",
        segment: "Retail food",
      },
      {
        id: 73,
        ordre: 6,
        code: "EMPORT_AUT",
        nom: "Autres Vente à Emporter",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/ce/0b/de/ce0bde67d3bd6ff5b0beb739bbdcaf9a.jpg",
        favori: 0,
        segment: "Retail food",
      },
      {
        id: 19,
        ordre: 10,
        code: "REST_RAPID",
        nom: "Restauration rapide",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/54/0c/06/540c067a1fc23d51e96c5b871e3c5e30.jpg",
        favori: 1,
        segment: "Retail food",
      },
    ],
  },
  {
    id: 6,
    ordre: 0,
    code: "MAGASIN",
    nom: "Retail / Vente",
    categories: [
      {
        id: 53,
        code: "MAGASIN",
        nom: "Magasin spécialisé",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/a9/59/2b/a9592b06be06763b601c81ca8bf19fd1.jpg",
        segment: "Retail hors food",
      },
      {
        id: 94,
        code: "LOGISTIQUE",
        nom: "Logistique",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/57/e8/4e/57e84e7d58622959b20704d3fd546653.jpg",
        segment: "Retail hors food",
      },
      {
        id: 93,
        code: "LIVRAISON",
        nom: "Livraison",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/cb/14/11/cb141179b0eb11c2cc87dc9d27c90697.jpg",
        segment: "Retail hors food",
      },
      {
        id: 91,
        code: "FLEURISTE",
        nom: "Fleuriste",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/69/d3/33/69d33360aaae4664b5d65309663dbd48.jpg",
        segment: "Retail hors food",
      },
      {
        id: 95,
        code: "CHOCOLATIE",
        nom: "Chocolatier",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/ce/b4/52/ceb452bd36f4fbb923bf7d82ab31384b.jpg",
        segment: "Retail food",
      },
      {
        id: 62,
        code: "VENTELIGNE",
        nom: "Ecommerce",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/e8/64/ad/e864ad301a1c6878b430874aab00a015.jpg",
        segment: "Retail hors food",
      },
      {
        id: 61,
        code: "BOUTIQUE",
        nom: "Boutique Mode / Prêt à porter",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/e4/ac/bb/e4acbb0118d73372e4170f36165d224f.jpg",
        segment: "Retail hors food",
      },
      {
        id: 57,
        code: "EPICERIE",
        nom: "Épicerie",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/e5/e3/12/e5e312a081760921aa47859bdca00c4c.jpg",
        segment: "Retail food",
      },
      {
        id: 90,
        ordre: 1,
        code: "SUPERMARCH",
        nom: "Grande et Moyenne Distribution",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/9c/8a/df/9c8adf84a5e656b941c106ee6dfc6a65.jpg",
        favori: 1,
        segment: "Retail hors food",
      },
      {
        id: 75,
        ordre: 2,
        code: "GRD_MAGA",
        nom: "Grands magasins",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/9f/d4/8b/9fd48b2bda3a9901b20fe14e52185c95.jpg",
        favori: 0,
        segment: "Retail hors food",
      },
      {
        id: 74,
        ordre: 3,
        code: "LUXE",
        nom: "Boutique Luxe",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/1c/be/83/1cbe837ba03e4a2343b6f635eda7b258.jpg",
        favori: 0,
        segment: "Retail hors food",
      },
      {
        id: 76,
        ordre: 3,
        code: "LIVR_ALIM",
        nom: "Livraison alimentaire",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/72/cd/c3/72cdc3db8edce638ec7436fcba38f96e.jpg",
        favori: 1,
        segment: "Retail food",
      },
      {
        id: 77,
        ordre: 5,
        code: "RET_AUTRE",
        nom: "Autres Retail / Vente",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/ce/0b/de/ce0bde67d3bd6ff5b0beb739bbdcaf9a.jpg",
        favori: 0,
        segment: "Retail hors food",
      },
    ],
  },
  {
    id: 7,
    ordre: 4,
    code: "SANTE",
    nom: "Santé",
    categories: [
      {
        id: 71,
        code: "CENTR_SANT",
        nom: "Centre de Santé",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/ea/53/40/ea5340160db0d679d1396b0a08e962a0.jpg",
        segment: "Grands comptes",
      },
      {
        id: 72,
        code: "EHPAD",
        nom: "EHPAD",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/0a/4f/0c/0a4f0c50b7027226e29f350c9aa795e8.jpg",
        segment: "Grands comptes",
      },
      {
        id: 78,
        code: "HOPITAL",
        nom: "Hôpital",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/90/04/d2/9004d28cb596f2698e2b47704a2854fa.jpg",
        segment: "Grands comptes",
      },
      {
        id: 79,
        code: "CLINIQUE",
        nom: "Clinique",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/65/09/05/650905f02d6f65d238b63ee2585c25b7.jpg",
        segment: "Grands comptes",
      },
      {
        id: 80,
        code: "PHARMACIE",
        nom: "Pharmacie",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/7e/27/12/7e27129152b30a6b1e20c3de57835883.jpg",
        segment: "Grands comptes",
      },
      {
        id: 84,
        code: "RESISENIOR",
        nom: "Résidence Senior",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/31/46/68/314668ca1b16812ef23b2ff6f55782d3.jpg",
        segment: "Grands comptes",
      },
      {
        id: 85,
        code: "MRETRAITE",
        nom: "Maison de retraite",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/e2/d4/b7/e2d4b7e163b3b367bed698e828e83016.jpg",
        segment: "Grands comptes",
      },
      {
        id: 92,
        code: "FOYMEDICAL",
        nom: "Foyer d'Accueil Médical",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/f7/de/93/f7de9379bc213bd314dda12b8de378a5.jpg",
        segment: "Grands comptes",
      },
    ],
  },
  {
    id: 8,
    ordre: 5,
    code: "COLLECTIVE",
    nom: "Restauration Collective",
    categories: [
      {
        id: 81,
        code: "COLL_SANTE",
        nom: "Collective Santé",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/2c/c5/9f/2cc59f3a673af04d19275c4cee7ea152.jpg",
        favori: 1,
        segment: "Collective grands comptes",
      },
      {
        id: 82,
        code: "COLL_EDUC",
        nom: "Collective Éducation",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/81/e9/5f/81e95f227b5a594ad4a41af76dde069a.jpg",
        favori: 1,
        segment: "Collective grands comptes",
      },
      {
        id: 45,
        ordre: 0,
        code: "REST_COLLE",
        nom: "Collective Entreprise",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/2d/47/61/2d47612b682766bf4670deefbb5632ae.jpg",
        favori: 1,
        segment: "Collective grands comptes",
      },
    ],
  },
  {
    id: 9,
    ordre: 5,
    code: "EVENEMENT",
    nom: "Événementiel",
    categories: [
      {
        id: 87,
        code: "LOGISTIQ2",
        nom: "Logistique",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/57/e8/4e/57e84e7d58622959b20704d3fd546653.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
      {
        id: 89,
        code: "AGENCE",
        nom: "Agence",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/aa/3f/9e/aa3f9e86715afcdbeda46dee00adbf81.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
      {
        id: 33,
        ordre: 0,
        code: "SALLE_CONC",
        nom: "Salle de concert",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/8b/3d/61/8b3d612c3c389b92b3f3d78c95373811.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
      {
        id: 44,
        ordre: 0,
        code: "TRAITEUR",
        nom: "Traiteur",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/85/1d/67/851d67deb1c2fd2291f9a019f89e4fe3.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
      {
        id: 47,
        ordre: 0,
        code: "EVENT",
        nom: "Evénementiel",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/9a/cd/4f/9acd4f8c560fc2f672e57b9105342fb7.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
    ],
  },
  {
    id: 4,
    ordre: 6,
    code: "F_AUTRE",
    nom: "Autres",
    categories: [
      {
        id: 52,
        code: "CAMPING",
        nom: "Camping",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/aa/c2/bc/aac2bced31da88cc694452d63172d7df.jpg",
        segment: "Grands comptes",
      },
      {
        id: 59,
        code: "CAB_RECRUT",
        nom: "Cabinet de recrutement",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/99/65/94/99659412dabbfc2cbbc12c3e45d1ea68.jpg",
        segment: "Grands comptes",
      },
      {
        id: 70,
        code: "EXPL_AGRIC",
        nom: "Exploitation Agricole",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/3d/7e/25/3d7e25af576daa06ba343d33e0a23837.jpg",
        segment: "Retail hors food",
      },
      {
        id: 83,
        code: "PROPRETE",
        nom: "Propreté et Services",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/c5/dc/de/c5dcde4ea2f764ba987d0d97f5652cd8.jpg",
        segment: "Retail hors food",
      },
      {
        id: 43,
        ordre: 0,
        code: "FOOD_TRUCK",
        nom: "Food-Truck",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/ef/9d/e9/ef9de948b18aae68e9db9dd0d68dcc47.jpg",
        favori: 1,
        segment: "Traiteurs/Events",
      },
      {
        id: 46,
        ordre: 0,
        code: "LIVRAISON_",
        nom: "Livraison à Domicile",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/a4/49/0a/a4490aa531c2d2c8cddf42d6a4468ee5.jpg",
        favori: 1,
        segment: "Retail food",
      },
      {
        id: 48,
        ordre: 0,
        code: "MARQUE_ENT",
        nom: "Marque / Entreprise",
        photo: "https://s3-eu-west-1.amazonaws.com/extraprd/ad/f5/c4/adf5c44a839cdd606a62ad8f40c1f55b.jpg",
        favori: 1,
        segment: "Retail hors food",
      },
      {
        id: 49,
        ordre: 0,
        code: "AUTRE",
        nom: "Autres",
        photo: "https://extraprd.s3.eu-west-1.amazonaws.com/ce/0b/de/ce0bde67d3bd6ff5b0beb739bbdcaf9a.jpg",
        segment: "Retail food",
      },
    ],
  },
];
